import { Outlet } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { SessionProvider } from '@/contexts/SessionProvider'
import AppLayoutWrapper from '@/components/AppLayoutWrapper'
import RyuuAssistant from '@/components/RyuuAssistant'

export default function RootLayout() {
  return (
    <AuthProvider>
      <SessionProvider>
        <AppLayoutWrapper>
          <Outlet />
          <RyuuAssistant />
        </AppLayoutWrapper>
      </SessionProvider>
    </AuthProvider>
  )
}

